import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'vanishingTableSelection',
  components: {
    DataGridComp: require('./datagrid.vue').default,
  },
  props: {
    parent: {
      type: Object,
      required: true
    },
    billingGroups: {
      type: Array,
      default: [],
      required: true
    },
    dataSourceFun: {
      type: Function,
      required: true
    },
    dataSource: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    selection: {
      type: Function
    },
    label: {
      type: String,
      default: ''
    },
    displayField: {
      type: String,
      default: ''
    },
    valueField: {
      type: String,
      default: ''
    },
    parentModel: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      showDialog: false,
      selectedObj: null,
      displayedValue: '',
      billGroupSelectedId: '',
    }
  },
  created() {
   
  },
  watch: {

  },
  methods: {
    
    searchCustomers() {
      this.parent.getCustomers(this.billGroupSelectedId);
    },
    pageChange(pInfo) {
      if (this.config.pageOptions.page == pInfo.pageNumber && this.config.pageOptions.pageSize == pInfo.pageSize)
        return;

      this.config.pageOptions.page = pInfo.pageNumber;
      this.config.pageOptions.pageSize = pInfo.pageSize;

      this.dataSourceFun(this.billGroups, this.config.pageOptions);
    },
    rowSelected(info) {
      this.selectedObj = info.data;
      this.fillParentModel();
      this.showDialog = false;
      this.findCustomerProperties(this.selectedObj.customerKey);
    },
    
    fillParentModel() {
      if (this.parentModel == '')
        return;

      if (this.parentModel.includes('.')) {
        const arr = this.parentModel.split('.');
        if (arr.length == 1)
          this.parent[arr[0]] = this.selectedObj;
        else if (arr.length == 2)
          this.parent[arr[0]][arr[1]] = this.selectedObj;
        else if (arr.length == 3)
          this.parent[arr[0]][arr[1]][arr[2]] = this.selectedObj;
        else if (arr.length == 4)
          this.parent[arr[0]][arr[1]][arr[2]][arr[3]] = this.selectedObj;
        else if (arr.length == 5)
          this.parent[arr[0]][arr[1]][arr[2]][arr[3]][arr[4]] = this.selectedObj;
      } 
    },
    findCustomerProperties(custId) {
      //console.log(custId);
      this.parent.getProperties(custId)
    }


  }
}
